// WAX/USD spot price + 24h change, for the header price box (WaxPriceBox.tsx).
// Pulled straight from CoinGecko's public price endpoint — no API key
// needed, and it sends CORS headers for direct browser use. Separate from
// atomicApi.ts because this hits a completely different service (market
// price data, not the AtomicHub chain index).
const COINGECKO_URL =
  "https://api.coingecko.com/api/v3/simple/price?ids=wax&vs_currencies=usd&include_24hr_change=true";

export interface WaxPrice {
  usd: number;
  /** Percentage points, e.g. 5.3 for +5.3% or -2.1 for -2.1%. */
  change24h: number;
}

export async function fetchWaxPrice(): Promise<WaxPrice> {
  const res = await fetch(COINGECKO_URL);
  if (!res.ok) throw new Error(`CoinGecko request failed: ${res.status}`);
  const data = await res.json();
  const usd = data?.wax?.usd;
  const change24h = data?.wax?.usd_24h_change;
  if (typeof usd !== "number" || typeof change24h !== "number") {
    throw new Error("Unexpected CoinGecko response shape");
  }
  return { usd, change24h };
}
